import type { LandingMatchingContent } from '../../shared/content/landingMatchingContent.js';
import type { LandingEditorElementDefinition } from './landingEditorRegistry.js';

/** Keep demo copy, profile data and uploaded images in the regular CMS workflow. */
export const companyMatchingEditorDefinitions = (
  matching: LandingMatchingContent,
): LandingEditorElementDefinition[] => {
  const definitions: LandingEditorElementDefinition[] = [];
  const labels: Record<string, string> = {
    matching: 'Matchingtool',
    candidates: 'Profile',
    labels: 'Beschriftungen',
    windowTitle: 'Fenstertitel',
    badge: 'Demo-Hinweis',
    companyName: 'Unternehmensname',
    eyebrow: 'Portal-Bezeichnung',
    initials: 'Logo-Initialen',
    logoUrl: 'Unternehmenslogo',
    logoAlt: 'Logo-Beschreibung',
    cobrandLabel: 'Partner-Hinweis',
    cobrandLogoUrl: 'Partnerlogo',
    cobrandLogoAlt: 'Partnerlogo-Beschreibung',
    resultLabel: 'Ergebnisanzahl: Text',
    searchLabel: 'Suche: Beschriftung',
    searchPlaceholder: 'Suche: Platzhalter',
    filterLabel: 'Filter: Beschriftung',
    resetLabel: 'Filter zurücksetzen',
    allLabel: 'Alle Profile',
    emptyTitle: 'Keine Ergebnisse: Titel',
    emptyText: 'Keine Ergebnisse: Text',
    ctaText: 'Kontakt: Beschreibung',
    experienceValue: 'Erfahrungsformat ({value})',
    photoAlt: 'Profilbild-Beschreibung ({name})',
    ageValue: 'Altersformat ({age})',
    firstName: 'Vorname',
    age: 'Alter',
    origin: 'Herkunft',
    qualification: 'Qualifikation',
    profileImageUrl: 'Profilbild',
    workExperienceYears: 'Erfahrungsjahre',
    germanLevel: 'Deutschniveau',
    focusAreas: 'Tätigkeitsbereiche',
    profileDetails: 'Profildetails',
    currentProfession: 'Aktueller Beruf',
    education: 'Ausbildung',
    skills: 'Kenntnisse',
    experience: 'Erfahrung',
    documents: 'Dokumente',
    label: 'Bezeichnung',
    experienceYears: 'Berufserfahrung: Beschriftung',
    status: 'Interesse: Beschriftung',
    requestInterest: 'Interesse senden',
    interestRequested: 'Interesse gesendet',
    withdrawQuestion: 'Interesse zurücknehmen: Frage',
    withdrawDescription: 'Interesse zurücknehmen: Erklärung',
    keepInterest: 'Interesse behalten',
    withdraw: 'Zurücknehmen',
    documentUnavailable: 'Dokumente: Vertraulichkeitshinweis',
  };
  const fieldLabel = (path: string) => {
    const key = path.split('.').at(-1)!;
    return labels[key] ?? (/^\d+$/u.test(key) ? `Eintrag ${Number(key) + 1}` : key);
  };
  const root = 'companyPlatformHero.matching';
  const visit = (value: unknown, path: string, parentId: string) => {
    if (typeof value === 'string') {
      if (path.endsWith('.id')) return;
      const image = /\.(?:profileImageUrl|logoUrl|cobrandLogoUrl)$/u.test(path);
      definitions.push({
        id: path,
        path,
        parentId,
        section: 'companyMatching',
        kind: image ? 'image' : 'text',
        label: fieldLabel(path),
        multiline: !image && value.length > 70,
        typographyMode: 'none',
      });
      return;
    }
    if (!value || typeof value !== 'object') return;
    const candidate = /^companyPlatformHero\.matching\.candidates\.(\d+)$/u.exec(path);
    definitions.push({
      id: path,
      parentId,
      section: 'companyMatching',
      kind: 'container',
      label: candidate ? `Profil ${Number(candidate[1]) + 1}` : fieldLabel(path),
      ...(candidate ? { repeatPath: `${root}.candidates`, repeatIndex: Number(candidate[1]) } : {}),
    });
    Object.entries(value).forEach(([key, child]) => visit(child, `${path}.${key}`, path));
  };
  visit(matching, root, 'companyPlatformHero.demo');
  return definitions;
};
